import styled from 'styled-components'

export const StyledMenuItem = styled.div`
	position: relative;
	width: 50px;
	height: 50px;
	margin: 0 15px;
	@media (max-width: 1200px) {
		width: 270px;
		padding-left: 17px;
		height: 58px;
		margin: 0;
		border-bottom: 1px solid #CDCDCD;
		display: flex;
		align-items: center;
		& .tablet_arrow{
			display: block !important;
			position: absolute;
			right: 0;
		}
	}

	@media (max-width: 768px) {
		width: 320px;
		max-width: 100%;
		height: 58px;
		padding-left: 13px;
		& .tablet_arrow{
			display: none !important;
		}
		& .mobile_arrow{
			display: block !important;
			position: absolute;
			right: 25px;
			top: 19px;
		}
	}

	@media (max-height: 610px) {
		height: 36px;
		width: 270px;
		& .tablet_arrow{
			display: block !important;
		}
		& .mobile_arrow{
			display: none !important;
		}
	}

	& .icon_wrapper{
		@media (max-width: 1200px) {
			width: 50px;
			height: 50px;
		}
		@media (max-height: 610px) {
			width: 35px;
			& svg{
				width: 35px;
			}
		}
	}
	.link-text{
		@media (max-width: 1200px) {
			display: block !important;
			margin-left: 5px;
			& span{
				font-size: 14px;
				font-weight: 500;
				color: #434343;
			}
			& p{
				font-size: 10px;
				font-weight: 400;
				color: #B0B0B0;
				margin-bottom: 0;
			}
		}

		@media (max-width: 767px) {
			margin-left: 9px;
			& span{
				font-size: 16px;
			}
			& p{
				font-size: 12px;
			}
		}
		@media (max-height: 610px) {
			& span{
				font-size: 14px;
			}
			& p{
				font-size: 10px;
			}
		}
	}
	& .arrow {
		display: none;
	}
`
